<template>
  <div class="proposal-carry-part">
    <!-- <div class="item-title">{{$t('page_content_proposal_carry_part}}</div> -->
    <div class="search-hd">
      <el-button
        v-if="actionEnable && orderType === 'caseOrder'"
        type="primary"
        icon="el-icon-plus"
        :disabled="!info.caseOrderId"
        @click="onAdd"
      >{{$t('Common.com_add')}}</el-button>
    </div>
    <div class="table-bd">
      <custom-table
        max-height="400px"
        :data="tableList"
        :tableCode="tableCode"
        :index="true"
        @filter="filterChange"
        @sort="sortChange"
        :slots="['action']"
        :filterArr="orderType === 'caseOrder' ? [] : ['action']"
      >
        <template v-slot:action="scope">
          <el-button
            v-if="actionEnable"
            type="text"
            size="mini"
            @click="onEdit(scope.row)"
          >{{$t('Common.com_edit')}}</el-button>
          <el-button
            v-if="actionEnable"
            type="text"
            size="mini"
            @click="onDel(scope.row)"
          >{{$t('Common.com_delete')}}</el-button>
        </template>
      </custom-table>
    </div>
    <!-- 分页 -->
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <bind-part-dialog
      v-if="bindPartVisible"
      :model="bindPartModel"
      @close="bindPartVisible = false"
      @success="onSuccess"
    ></bind-part-dialog>
    <edit-part-num-dialog
      v-if="editPartNumVisible"
      @close="editPartNumVisible = false"
      :model="editPartNumModel"
      @success="getTableList"
    ></edit-part-num-dialog>
  </div>
</template>

<script>
/**
 * 建议携带零件组件：
 *
 * 案例-维修：
 * 新增，编辑数量，删除
 *
 * 工单-维修：
 * 新增，编辑数量，删除
 */
import apis from '@/utils/apis';
import bindPartDialog from './bind_part_dialog';
import editPartNumDialog from './edit_part_num_dialog';

export default {
  name: '',
  inject: ['getCaseInfo', 'checkActionEnable'],
  mixins: [],
  components: { bindPartDialog, editPartNumDialog },
  props: {
    orderDeviceId: [Number, String],
    orderType: [Number, String],
  },
  data() {
    return {
      tableCode: 'proposal_carry_part',
      tableList: [],
      totalRows: null,
      formSearch: {
        pageNum: 1,
        pageSize: 50,
        search: '',
      },
      bindPartVisible: false,
      bindPartModel: {},
      editPartNumVisible: false,
      editPartNumModel: {},
      suggestReplaceList: []
    };
  },
  computed: {
    info() {
      return this.getCaseInfo();
    },
    actionEnable() {
      return this.checkActionEnable();
    },
  },
  watch: {
    orderDeviceId: {
      immediate: true,
      handler(val) {
        if (val && this.info.caseOrderId) {
          this.init();
        }
      },
    },
  },
  methods: {
    onAdd() {
      this.bindPartModel = {
        title: this.$t('asm_proposal_carry_part.tian_jia_ling_jian'),
        data: this.info,
      };
      this.bindPartVisible = true;
    },
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    getTableList() {
      this.$getJSON(apis.caseOrderPartPage, {
        orderDeviceId: this.orderDeviceId,
        ...this.formSearch,
      }).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    onSuccess() {
      this.onPageChange({ page: 1 });
    },
    init() {
      this.getTableList();
      this.getSuggestReplaceList();
    },
    // 获取系统建议更换零件
    getSuggestReplaceList() {
      this.$getJSON(apis.caseOrderPartSysList, {
        productCode: this.info.productCode,
        bodyNum: this.info.bodyNum
      }).then((res) => {
        this.suggestReplaceList = res.data || [];
      });
    },
    onDel(row) {
      this.$showConfirm(this.$t('asm_proposal_carry_part.nqdyscxzdljm')).then(() => {
        this.$postJSON(`${apis.caseOrderPartDelete}/${row.orderPartId}`, {}, true).then(() => {
          this.$message({
            message: this.$t('Common.com_delete_success'),
            type: 'success',
          });
          this.getTableList();
        });
      });
    },
    onEdit(row) {
      this.editPartNumModel = {
        title: this.$t('asm_proposal_carry_part.bjljsl'),
        data: row,
      };
      this.editPartNumVisible = true;
    },
  },
  created() { },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.proposal-carry-part {
  padding: 16px;
  .search-hd {
    padding-top: 0;
  }
}
</style>
